import { render, staticRenderFns } from "./DetailItemOrder.vue?vue&type=template&id=b692c330&scoped=true"
import script from "./DetailItemOrder.vue?vue&type=script&lang=js"
export * from "./DetailItemOrder.vue?vue&type=script&lang=js"
import style0 from "./DetailItemOrder.vue?vue&type=style&index=0&id=b692c330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b692c330",
  null
  
)

export default component.exports